import script from "./PrescriptionRule.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrescriptionRule.vue?vue&type=script&setup=true&lang=ts"

import "./PrescriptionRule.vue?vue&type=style&index=0&id=c22f20a2&lang=scss"

const __exports__ = script;

export default __exports__